"use client";
import { useRef, type ComponentProps } from "react";

import { useHorizontalOverflow } from "@/lib/use-horizontal-overflow";

/*
 * A wide table scrolls inside the response. Its scrollbar is the app's quiet
 * one (scrollbar-thin), shown only under the pointer or keyboard focus, and it
 * scrolls sideways only, so it keeps no gutter for a vertical bar. The edge
 * that still hides columns fades out (mlx-scroll-fade[data-overflow] in
 * globals.css) to show there is more.
 */
export function ScrollableTable(props: ComponentProps<"table">) {
  const ref = useRef<HTMLDivElement>(null);
  const overflow = useHorizontalOverflow(ref);
  return (
    <div ref={ref} className="typeset-scroll mlx-scroll-fade scrollbar-thin [scrollbar-gutter:auto]" role="region" aria-label="Table" tabIndex={0} data-overflow={overflow}>
      <table {...props} />
    </div>
  );
}
